const siderBar = {
  profile: "프로필",
  history: "역사 프로젝트",
  setting: "설정",
  promotion: "프로모션",
};

export default siderBar;